import { render, staticRenderFns } from "./region-orders.vue?vue&type=template&id=04486df0&scoped=true&"
import script from "./region-orders.js?vue&type=script&lang=js&"
export * from "./region-orders.js?vue&type=script&lang=js&"
import style0 from "./region-orders.scss?vue&type=style&index=0&id=04486df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04486df0",
  null
  
)

export default component.exports